// create forgetPassword action
import { z } from "zod";
import { mapErrorsToFields } from "../../../utils";
import AuthService from "../../../services/AuthService";
import { AxiosError } from "axios";

export type State = {
  errors?: {
    email?: string[];
    general?: string[];
  };
  success?: boolean;
  error?: {
    message: string;
    code: string;
  };
  defaultValues?: {
    email: string;
  };
};
const FormSchema = z.object({
  email: z.email({
    error: "Email is not valid",
  }),
});
const api = new AuthService();
export async function forgetPassword(
  prevState: State | undefined,
  data: FormData
): Promise<State> {
  const defaultValues = {
    email: data.get("email")?.toString() || "",
  };

  const result = FormSchema.safeParse(defaultValues);
  console.log(result);
  if (!result.success) {
    const errors = mapErrorsToFields(result.error);
    return { ...prevState, errors, error: undefined };
  }
  
  try {
    const response = await api.forgetPassword({
      email: data.get("email") as string,
    });
    const success = response.status === 200;
    if (success)
      return {
        errors: {},
        defaultValues: defaultValues,
        error: undefined,
        success: success,
      };
  } catch (ex: AxiosError | any) {
    console.log({ ex });
    return {
      errors: {},
      defaultValues: defaultValues,
      error: {
        message: ex.response.data.description,
        code: ex.response.data.code,
      },
      success: false,
    };
  }

  return {
    errors: {},
    defaultValues: defaultValues,
    error: {
      message: "Failed to send reset password email.",
      code: "ForgetPassword.error",
    },
    success: false,
  };
}
